import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icon/search.png'


const _withScopeId = n => (_pushScopeId("data-v-75dee670"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "input-wrapper" }
const _hoisted_2 = ["placeholder"]

import { ref } from 'vue';
  import { useI18n } from 'vue-i18n';
  import { request } from '@/utils';
  import { ICharity } from '@/types/charity';

  
export default /*#__PURE__*/_defineComponent({
  emits: ["search"],
  setup(__props, { emit: emits }: { emit: ({(e: 'search', list: ICharity[]): void }), expose: any, slots: any, attrs: any }) {

  const { t } = useI18n();
  const searchText = ref('');
  

  // 搜索
  async function handleSearch() {
    closeSearchResult();
    const res = await request.get('charities', { params: { name_cont: searchText.value } });
    emits('search', res.data);
    document.addEventListener('click', closeSearchResult);
  }

  function closeSearchResult() {
    document.removeEventListener('click', closeSearchResult);
  }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "search-wrapper",
    onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"]))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _withDirectives(_createElementVNode("input", {
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchText).value = $event)),
        type: "text",
        class: "input",
        placeholder: _unref(t)('Search programs')
      }, null, 8, _hoisted_2), [
        [_vModelText, searchText.value]
      ]),
      _createElementVNode("img", {
        src: _imports_0,
        class: "icon-search",
        onClick: handleSearch
      })
    ])
  ]))
}
}

})